// extracted by mini-css-extract-plugin
export default {"Layout":"UserSettings_Layout_Layout__0Pjr9","Wrapper":"UserSettings_Layout_Wrapper__OSxF-"};